import capitalizeFirstLetter from "./capitalizeFirstLetter";

export function convertSubsToNested(subs: { label: string; value: string }[]): Array<{ label: string; value?: string; children?: Array<{ label: string; value: string }> }> {
  const groups: Record<string, Array<{ label: string; value: string }>> = {};
  const topLevel: Array<{ label: string; value: string }> = [];

  subs.forEach(sub => {
    if (sub.value.includes(".")) {
      const [prefix, ...rest] = sub.value.split(".");
      if (!groups[prefix]) groups[prefix] = [];
      groups[prefix].push({
        label: sub.label,
        value: `{{${prefix}.${rest.join(".")}}}`,
      });
    } else {
      topLevel.push({
        label: sub.label,
        value: `{{${sub.value}}}`,
      });
    }
  });

  const result: Array<{ label: string; value?: string; children?: Array<{ label: string; value: string }> }> = [
    ...topLevel,
    ...Object.entries(groups).map(([group, children]) => ({
      label: capitalizeFirstLetter(group),
      children,
    })),
  ];

  console.log("Converted substitutions to nested structure:", result);

  return result;
}